<script>
export default {
    name: "VisitReport",

    data() {

        return {
            patients: [],
        };
    },

    computed: {

        totalNewVisits() {
            const patients = this.patients.filter(pat => pat.visitCount == 1);

            return patients.length
        },

        totalBelow5() {
            const patients = this.patients.filter(test => test.age < 5);

            return patients.length;
        },

        totalAbove5() {
            const patients = this.patients.filter(test => test.age >= 5);

            return patients.length;
        },
    },

    mounted() {
        Promise.all([ this.fetchPatients(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchPatients() {

            let url = `PatientsReports/GetPatientVisitReportAll`;
                url += `?dateFrom=${this.$route.query.dateFrom}`;
                url += `&dateTo=${this.$route.query.dateTo}`;

            return this.$http.get(url).then(({ data }) => {
                this.patients = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="flex-1 text-center my-2">
            <h5 class="font-medium uppercase">Visit Report</h5>
        </div>
        <table class="table table-hover" id="patientVisitReportTable">
                  <thead class="bg-blue-500 text-xs text-white">
                      <tr class="w-full flex">
                          <th class="p-tiny flex-1">MRN</th>
                          <th class="p-tiny w-1/6">Patient</th>
                          <th class="p-tiny flex-1">IPNo</th>
                          <th class="p-tiny flex-1">Age</th>
                          <th class="p-tiny flex-1">Residence</th>
                          <th class="p-tiny flex-1">Visit</th>
                          <th class="p-tiny flex-1">Clinic</th>
                          <th class="p-tiny w-1/12">PMode</th>
                          <th class="p-tiny flex-1">Clinic</th>
                          <th class="p-tiny flex-1">Doctor</th>
                          <th class="p-tiny flex-1">User</th>
                          <th class="p-tiny flex-1">Diagnosis</th>
                          <th class="p-tiny flex-1">Date</th>
                          <th class="p-tiny flex-1">Time</th>
                          <th class="p-tiny flex-1">Is Paid</th>
                          <th class="p-tiny flex-1">Action</th>
                      </tr>
                  </thead>
                  <tfoot>
                      <tr class="w-full flex">
                          <th class="p-tiny w-1/5"></th>
                          <th class="p-tiny w-1/5">Total Below 5: {{ totalBelow5 }}</th>
                          <th class="p-tiny w-1/5">Total Above 5: {{ totalAbove5 }}</th>
                          <th class="p-tiny w-1/5">New Visits: {{ totalNewVisits }}</th>
                          <th class="p-tiny w-1/5 text-right">Total Visits: {{ patients.length }}</th>
                      </tr>
                  </tfoot>
                  <tbody 
                    class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" 
                    style="max-height:65vh;">
                      <tr class="flex w-full" v-for="(patient,idx) in patients" :key="idx">
                          <td class="p-tiny flex-1">{{ patient.customerId }}</td>
                          <td class="p-tiny w-1/6">{{ patient.names }}</td>
                          <td class="p-tiny flex-1">{{ patient.ipfileno || `-` }}</td>
                          <td class="p-tiny flex-1">{{ patient.age }}</td>
                          <td class="p-tiny flex-1">{{ patient.residence }}</td>
                          <td class="p-tiny flex-1">
                              {{ 
                                patient.visitCount > 1 ? 
                                    `${patient.visitCount} Visits` : 
                                    `New Visit` 
                              }}
                          </td>
                          <td class="p-tiny w-1/12 break-words">{{ patient.pMode }}</td>
                          <td class="p-tiny flex-1 break-words">{{ patient.clinic }}</td>
                          <td class="p-tiny flex-1 break-words">{{ patient.doctor }}</td>
                          <td class="p-tiny flex-1 break-words">{{ patient.userName }}</td>
                          <td class="p-tiny flex-1 break-words">{{ patient.diagnosis }}</td>
                          <td class="p-tiny flex-1 break-words">{{ patient.date | dateFormat }}</td>
                          <td class="p-tiny flex-1 break-words">{{ patient.time }}</td>
                          <td class="p-tiny flex-1 break-words">{{ patient.isPaid ? `Yes` : `No` }}</td>
                          <td class="p-tiny flex-1 break-words flex flex-col">
                              <button 
                                @click.prevent="() => {
                                    fetchPatient(patient.customerId).then(() => {
                                        patient.viewTreatment = true;
                                    });
                                }"
                                class="btn-sm btn-primary text-xs m-px rounded">
                                  Treatment Details</button>
                              <button 
                                @click.prevent="() => {
                                    fetchPatient(patient.customerId).then(() => {
                                        patient.view = true;
                                    });
                                }"
                                class="btn-sm btn-info text-xs m-px rounded">
                                    Patient Details</button>
                              <patient-details-modal 
                                :patient="patientDetails"
                                :showModal="patient.view"
                                @closeModal="patient.view = false"
                              />
                              <visit-treatment 
                                :patient="{ ...patientDetails, ...patient}"
                                :showModal="patient.viewTreatment"
                                @closeModal="patient.viewTreatment = false"
                              />
                          </td>
                      </tr>
                  </tbody>
              </table>
    </div>
</template>